import { EActiveView } from '../../types/view';
import { EConfirmPhoneStatus } from '../../types/registration';
import { ESentEmailType } from '../../types/sentEmail';
import { REGISTRATION_CONFIRM_PHONE_TYPE } from '../../constants/action_types';
import { confirmPhone as confirmPhoneApi, ESavePhoneStatus } from '../../api/confirmPhone';
import { changeView } from '../view';
import { EEventType } from '../../types/events';
import { trackRegistrationSmsValidationFail } from '../../utils/tracking';
export function confirmPhone(_ref) {
  var email = _ref.email,
    phone = _ref.phone,
    code = _ref.code,
    source = _ref.source;
  return function (dispatch, _getState, context) {
    dispatch({
      status: EConfirmPhoneStatus.Loading,
      type: REGISTRATION_CONFIRM_PHONE_TYPE
    });
    return confirmPhoneApi(context.httpApi, {
      email: email,
      phone: phone,
      confirmed: true,
      confirmationCode: code
    }).then(function (response) {
      if (response.statusCode === 200) {
        if (response.response.status.value === ESavePhoneStatus.Success) {
          dispatch({
            status: EConfirmPhoneStatus.Succeed,
            type: REGISTRATION_CONFIRM_PHONE_TYPE
          });
          dispatch(changeView(EActiveView.EmailSent, {
            type: ESentEmailType.Registration
          }));
          context.emitter.emit(EEventType.ConfirmPhoneSucceed);
          return;
        } else {
          if (response.response.status.value === ESavePhoneStatus.ValidationFailed) {
            trackRegistrationSmsValidationFail(source);
          }
          dispatch({
            status: EConfirmPhoneStatus.Failed,
            type: REGISTRATION_CONFIRM_PHONE_TYPE,
            error: response.response.status.message || 'Произошла непредвиденная ошибка'
          });
          return;
        }
      }
      dispatch({
        status: EConfirmPhoneStatus.Failed,
        type: REGISTRATION_CONFIRM_PHONE_TYPE,
        error: 'Произошла непредвиденная ошибка'
      });
    }).catch(function (error) {
      context.logger.error(error, {
        domain: 'auth-widget.api.confirmPhone'
      });
      dispatch({
        status: EConfirmPhoneStatus.Failed,
        type: REGISTRATION_CONFIRM_PHONE_TYPE,
        error: 'Произошла непредвиденная ошибка'
      });
    });
  };
}